import unifiedPharmacyList from "./unified-pharmacy-list/UnifiedPharmacyList.vue";
import i18n from "../../i18n/index";
import unifiedPharmacyService from "../../services/unified-pharmacy/UnifiedPharmacyService";

export default {
  components: {
    unifiedPharmacyList
  },
  data: () => ({
    hideList: false,
    loading: false,
    unifiedPharmacies: [],
    unifiedPharmacy: {
      id: null,
      name: '',
      active: ''
    },
    rules: [value => !!value || i18n.t('field-required')],
    loadingDelete: false,
    chkUnifiedPharmacy: false,
    loadingSaveButton: false,
    showAdd: true,
    showIcon: false,
    showUpdate: false,
    showDelete: false
  }),
  mounted() { },
  methods: {
    handle(item) {
      this.hideList = true;
      this.loadingSaveButton = false;
      this.unifiedPharmacy.id = item.id;
      this.unifiedPharmacy.name = item.name;
      this.chkUnifiedPharmacy = item.active;
      this.showAdd = false;
      this.showIcon = false;
      this.showUpdate = true;
      this.showDelete = true;
    },
    close() {
      this.hideList = false;
      this.loadingSaveButton = false;
      this.unifiedPharmacy = {
        id: null,
        name: '',
        active: ''
      };
      this.$refs.unifiedPharmacyList.get();
      this.showAdd = true;
      this.showUpdate = false;
      this.showIcon = false;
      this.showDelete = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loadingSaveButton = true;
        unifiedPharmacyService.create(this.unifiedPharmacy).then(value => {
          this.close();
        }).catch(error => {
          this.loadingSaveButton = false;
        });
      }
    },
    deleteUnifiedPharmacy() {
      let data = { id: this.unifiedPharmacy.id };
      this.loadingDelete = true;
      unifiedPharmacyService.delete(data).then(result => {
        if (result.status == 200 || result.status == 201) {
          this.loadingDelete = false;
          this.$notify({
            group: "app",
            type: "success",
            text: 'Farmacia Unificada Eliminada'
          });
          this.$refs.unifiedPharmacyList.get();
          this.close();
        }
      }).catch(error => {
        this.loadingDelete = false;
        this.showIcon = false;
        if (error && error.code) {
          if (error.code == 'The unified pharmacy has associated transactions') {
            this.$notify({
              group: "app",
              type: "error",
              text: i18n.t("unified-pharmacy-has-transactions")
            })
          }
        }
        this.$refs.unifiedPharmacyList.get();
        this.close();
      });
    },
    update() {
      let unifiedPharmacyId = this.unifiedPharmacy.id;
      this.unifiedPharmacy.active = this.chkUnifiedPharmacy;
      let data = {
        name: this.unifiedPharmacy.name,
        active: this.unifiedPharmacy.active == true ? 1 : 0,
      };
      this.loadingSaveButton = true;
      this.showIcon = true;

      unifiedPharmacyService.update(unifiedPharmacyId, data).then(result => {
        this.loadingSaveButton = false;
        if (result.status == 200 || result.status == 201) {
          this.$notify({
            group: "app",
            type: "success",
            text: "Farmacia Unificada Actualizada"
          });
          this.$refs.unifiedPharmacyList.get();
          this.close();
        }
      }).catch(error => {
        this.loadingSaveButton = false;
        this.showIcon = false;
        if (error && error.code) {
          if (error.code == 'The unified pharmacy has associated transactions') {
            this.$notify({
              group: "app",
              type: "error",
              text: i18n.t("unified-pharmacy-has-transactions")
            })
          }
        }
        this.$refs.unifiedPharmacyList.get();
        this.close();
      });
    }
  }
};
